import * as React from 'react';
import { PackageSearchIcon } from 'lucide-react';
import type { SapStatus } from 'contracts/redirected-products';
import { cn } from 'lib/utils';

type Props = {
  status: SapStatus;
}

export const SapStatusIndicator = ({ status }: Props) => {
  const iconTitle = React.useMemo(() => {
    return status === 'pending'
      ? 'SAP Pendente'
      : 'SAP Realizado';
  }, [status]);

  return (
    <div title={iconTitle} className={cn(
      'w-5 h-5 rounded-full bg-gray-600 text-white',
      'flex items-center justify-center',
      status === 'pending' && 'bg-yellow-500',
      status === 'done' && 'bg-green-500',
    )}>
      <PackageSearchIcon className={'w-4 h-4'} />
    </div>
  );
};